import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";

const Columns = ({ onCliclNavigate, currentPage, pageSize }) => [
  {
    dataField: "",
    text: "SrNo",
    formatter: (cell, row, rowIndex) => (
      <span className="text-capitalize cursor-pointer hover-lightblue">
        {(currentPage - 1) * pageSize + (rowIndex + 1)}
      </span>
    ),
  },
  {
    dataField: "group_summary",
    text: "Group Summary",
    formatter: (_, row) => {
      const words = row.summary?.split(" ") || [];
        const truncatedMsg = words.length > 20 ? words.slice(0, 20).join(" ") + " ..." : row.msg;
        return <span className="text-capitalize cursor-pointer">{truncatedMsg}</span>;
      // <span className="text-capitalize cursor-pointer" >{row.summary}</span>
    },
  },
  {
    dataField: "feedback_id",
    text: "Feedback Ids",
    formatter: (_, row) => (
      <span className="text-capitalize cursor-pointer" >{Array.isArray(row.feedback_id) ? row.feedback_id.join(", ") : row.feedback_id}</span>
    ),
  },
  {
    text: "Created At",
    dataField: "createdAt",
    formatter: (_, row) => DATE_FORMAT(row.createdAt),
  },
  {
    text: "Action",
    dataField: "",
    formatter: (_, row) => (
      <>
        <span className="d-flex ">
          <button
            className="fa fa-eye"
            style={{
              fontSize: "20px",
              color: "green",
              backgroundColor: "#fff",
              border: "none",
            }}
            title="View"
            onClick={() => onCliclNavigate(row.summary)}
          ></button>
        </span>
      </>
    ),
  },
];
export default Columns;
